import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { Grid, Box, DialogContent } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { IJobBoardSaveDTO, deleteJobBoardAccount, IJobBoard } from 'wisestep-api';
import {
  WsDialog,
  WsDialogSize,
  WsTypography,
  WsTypoVariants,
  ControlledTextInput,
  WsButton,
} from 'wisestep-base';
import { object, string } from 'yup';

import { useNotificationStore } from '../../../../utils/NotificationStore';
import {
  publishEmailValues,
  publishJobBoardValues,
} from '../../../jobs/publish/components/helper/jobBoardHelper';
import { deleteAccountSuccess, deleteAccountFailed } from '../helper/jobBoardSettingsHelper';

const validationSchema = object().shape({
  password: string()
    .min(4, 'Password must be at least 4 characters')
    .required('Password is required'),
});
interface DeleteAccountProps {
  openDeleteAccountPopup: boolean;
  selectedAccountName: string;
  selectedAccountId: string;
  selectedAccountPassword: string;
  closeDeleteAccountPopup: () => void;
}

const DeleteAccount = ({
  openDeleteAccountPopup,
  selectedAccountName,
  selectedAccountId,
  selectedAccountPassword,
  closeDeleteAccountPopup,
}: DeleteAccountProps) => {
  const setNotification = useNotificationStore((state) => state.setNotification);

  const jobBoardSave: IJobBoardSaveDTO = {
    jobBoard: publishJobBoardValues,
    email: publishEmailValues,
  };

  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: { password: '' },
  };

  const methods = useForm<IJobBoard>(formOptions);

  const { handleSubmit } = methods;

  const onFormSubmit = async (data: IJobBoard) => {
    publishJobBoardValues.password = data.password;
    jobBoardSave.jobBoard = publishJobBoardValues;
    try {
      if (data.password == selectedAccountPassword) {
        await deleteJobBoardAccount(selectedAccountId);
        setNotification(deleteAccountSuccess());
      } else {
        setNotification(deleteAccountFailed());
      }
      closeDeleteAccountPopup();
    } catch (e) {
      setNotification(deleteAccountFailed());
    }
  };

  return (
    <WsDialog openDialog={openDeleteAccountPopup} size={WsDialogSize.MEDIUM}>
      <FormProvider {...methods}>
        <DialogContent>
          <Box p={3} component="form" onSubmit={handleSubmit(onFormSubmit)}>
            <Grid container p={1}>
              <Grid item xs={11} display="flex" alignItems={'center'}>
                <WsTypography variant={WsTypoVariants.SUB_TITLE}>
                  Are you sure you want to delete this Account?
                </WsTypography>
              </Grid>
              <Grid item xs={1} display="flex" alignItems={'center'} justifyContent={'flex-end'}>
                <CloseIcon fontSize="medium" cursor={'pointer'} onClick={closeDeleteAccountPopup} />
              </Grid>
              <Grid item xs={12} pt={2} columnGap={3}>
                <ControlledTextInput
                  name="password"
                  labelText={`Password* (${selectedAccountName})`}
                  type="password"
                  fullWidth
                  id="outlined-basic"
                  placeholder="Enter password"
                  variant="outlined"
                  required
                  autoComplete="password"
                />
              </Grid>
              <Grid item xs={12} pt={4} display="flex" justifyContent={'flex-end'} columnGap={2}>
                <WsButton variant="contained" size="large" type="submit" startIcon={<CloseIcon />}>
                  Delete Account
                </WsButton>
                <WsButton
                  size="large"
                  startIcon={<DoNotDisturbAltIcon />}
                  onClick={closeDeleteAccountPopup}
                >
                  Cancel
                </WsButton>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </FormProvider>
    </WsDialog>
  );
};

export default DeleteAccount;
